import { Box, Theme, useMediaQuery } from '@mui/material';
import { AppBar, TitlePortal, UserMenu } from 'react-admin';

const CustomAppBar = () => {
  const isLargeEnough = useMediaQuery<Theme>((theme) =>
    theme.breakpoints.up('sm')
  );
  return (
    <AppBar color="secondary" userMenu={<UserMenu label="Menum" />}>
      <TitlePortal />

      {isLargeEnough && <Box component="span" sx={{ flex: 1 }} />}
    </AppBar>
  );
};

export default CustomAppBar;
